<template>
  <ReactiveDynamicForm
    :schema="schema"
    :entity-id="entityId"
  ></ReactiveDynamicForm
></template>

<script>
export default {
  components: {
    ReactiveDynamicForm: () => import('../ReactiveDynamicForm')
  },
  props: {
    entityId: {
      type: String,
      required: true
    },
    schema: {
      type: Object,
      required: true
    }
  }
}
</script>
